
import { Component, Vue } from "vue-property-decorator";
import LogoAppBar from "@/components/app/LogoAppBar.vue";
import RestaurantContactCard from "@/components/restaurant/RestaurantContactCard.vue";
import Restaurant from "@/domain/restaurant/Restaurant";
import ConfirmationDialog from "@/components/alert/ConfirmationDialog.vue";
import BookingOverviewComponent from "@/components/booking/components/BookingOverviewComponent.vue";
import Booking from "@/domain/booking/Booking";
import Loading from "@/components/app/Loading.vue";
import RemoteServices from "@/services/RemoteServices";
import TimeService from "@/services/TimeService";
import PrivacyWarning from "@/components/app/PrivacyWarning.vue";
import ReCaptchaV3 from "@/domain/ReCaptchaV3";
@Component({
  components: {
    PrivacyWarning,
    Loading,
    BookingOverviewComponent,
    ConfirmationDialog,
    RestaurantContactCard,
    LogoAppBar
  }
})
export default class ManageBookingView extends Vue {
  restaurant: Restaurant | null = new Restaurant();

  booking: Booking | null = null;

  loading = true;

  recaptcha!: ReCaptchaV3;


  async mounted() {
    this.recaptcha = new ReCaptchaV3((process.env.VUE_APP_RECAPTCHA_KEY!));
    await this.getBookingPublic();
  }

  get appIsReady(){
    return this.$store.getters.getLoading === false;
  }

  async pushOnlineBookingPage(){
    await this.$router.push({ name: 'Online Booking', query: {restId: this.restaurant?.restaurantId.toString()}})
  }

  get confirmationDialog() {
    return this.$refs.confirmationDialog as ConfirmationDialog;
  }

  get statusDisplayString() {
    if (this.booking != null)
      return Booking.getBookingStatusDisplayString(this.booking?.status);
    return "ERROR";
  }

  get displayDate() {
    if (this.booking != null)
      return TimeService.getDateTimeDisplayStringFromISO(
        this.booking.bookingDateTime
      );
    return "Date";
  }

  get showCancelled() {
    if (this.booking != null)
      return (
        this.booking.status === "CANCELLED" ||
        this.booking.status === "CANCELLED_ONLINE" ||
        this.booking.status === "NO_SHOW"
      );
    return false;
  }

  get canCancelBooking() {
    if (this.booking != null)
      return (
           Booking.getStatusActive(this.booking.status) &&  !this.booking.isSeated() && !this.booking.isComplete()
        && TimeService.dateIsBeforeOrEqual(Restaurant.getDateTimeAtRestaurant(this.restaurant!).toDate(), new Date(this.booking.bookingDateTime))

      );
    return false;
  }

  async cancelBookingPublic() {
    if (this.$route.query.bookingId != null && this.$route.query.key != null) {
      try {
        if (
            await this.confirmationDialog.open(
                this.$tc("booking.cancel.label"),
                this.$tc("delete.warning")
            )
        ) {
          await this.$store.dispatch("loading");
          this.loading = true;
          const token = await this.getCaptchaToken("cancelBooking");
          Booking.updateBooking(this.booking as Booking, await RemoteServices.cancelBookingPublic(
              parseInt(this.$route.query.bookingId as string),
              this.$route.query.key as string,
              token
          ))
          await this.$store.dispatch("success", this.$tc("booking.cancel.success"))
        }
      } catch (error) {
        console.log(error.message);
        await this.$router.push({ name: '500'})
      }
    } else {
      await this.$router.push({ name: '404'});
    }
    await this.$store.dispatch("clearLoading");
    this.loading = false;
  }

  async getBookingPublic() {
    await this.$store.dispatch("loading");
    this.loading = true;
    if (this.$route.query.bookingId != null && this.$route.query.key != null) {
      try {
        this.booking = await RemoteServices.getBookingPublic(
          parseInt(this.$route.query.bookingId as string),
          this.$route.query.key as string
        );
        this.restaurant = new Restaurant(this.booking.restaurantDto);
      } catch (error) {
        console.log(error.message);
        await this.$router.push({ name: '500'})
      }
    } else {
      await this.$router.push({ name: '404'});
    }
    this.loading = false;
    await this.$store.dispatch("clearLoading");

  }

  async getCaptchaToken(action: string) {
    return await this.recaptcha.getToken(action);
  }
}
